import { useTranslation } from 'next-i18next';
import { FC, ReactNode } from 'react';
import Icon from 'src/common/components/IconDS22';
import ModalHeader from 'src/common/components/Modal/Header';
import useWizardFlow from 'src/common/components/WizardFlow/useWizardFlow';
import styles from './WizardNavigation.module.scss';

type HeaderProps = {
  children: ReactNode;
};

const WizardNavigation: FC<HeaderProps> = ({ children }) => {
  const { t } = useTranslation('admin-common');
  const { active, back } = useWizardFlow();
  return (
    <ModalHeader>
      {active != null && (
        <button
          type="button"
          onClick={back}
          className={styles.backButton}
        >
          <Icon id="caret-left" />
          {t('modal-wizard--back')}
        </button>
      )}
      <h3 className={styles.title}>
        {children}
      </h3>
    </ModalHeader>
  );
};

export default WizardNavigation;
